import { userLogin } from "./apiCalls.js"

export function login(email, password) {
  return new Promise((resolve, reject) => {
    userLogin(email, password)
      .then(async (response) => {
        if (response.status === 200) {
          let responseJSON = await response.json()
          if (responseJSON.auth) {
            const { email, name, accessLevel } = responseJSON.user
            resolve({ email, name, accessLevel, token: responseJSON.token })
          } else {
            reject({ message: responseJSON.message, type: responseJSON.type })
          }
        } else {
          let responseJSON = await response.json()
          reject({ message: responseJSON.message, type: responseJSON.type })
        }
      })
      .catch((error) => reject({ message: error.message, type: error.type }))

    // setTimeout(() => {
    //   if (password && email) {
    //     let permissions = { readwrite: read_write_userlist.includes(email) }
    //     resolve({ email, permissions })
    //   } else {
    //     reject({ message: "Invalid username or password." })
    //   }
    // }, 3000) //
  })
}

export function verify(verficationCode) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (verficationCode.includes("123")) {
        resolve({ verficationCode })
      } else {
        reject({ message: "Invalid verification code." })
      }
    }, 3000)
  })
}
